import React from "react";
import { BecomeInsiderCTA } from "./ctas";
import { InsiderFreeShippingIA } from "./instantAnswersComponents/orders/InsiderFreeShippingIA";
export var insiderFreeShipping = function insiderFreeShipping(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_FREE_SHIPPING_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return INSIDER_FREE_SHIPPING_DESCRIPTION();
    }
  };
};
var INSIDER_FREE_SHIPPING_TITLE = function INSIDER_FREE_SHIPPING_TITLE(strictLocalize) {
  return strictLocalize({
    id: "3ZwLuu",
    defaultMessage: [{
      "type": 0,
      "value": "Livraison gratuite avec Insider"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return BecomeInsiderCTA(strictLocalize);
};
var INSIDER_FREE_SHIPPING_DESCRIPTION = function INSIDER_FREE_SHIPPING_DESCRIPTION() {
  return /*#__PURE__*/React.createElement(InsiderFreeShippingIA, null);
};